import { createContext, useContext, useRef, type ReactNode } from "react";

interface RecordingControlsContextType {
  dismissSilenceWarningRef: React.MutableRefObject<(() => void) | null>;
  pauseRecordingRef: React.MutableRefObject<(() => void) | null>;
  stopRecordingRef: React.MutableRefObject<(() => void) | null>;
  continueRecordingRef: React.MutableRefObject<(() => void) | null>;
}

const RecordingControlsContext = createContext<RecordingControlsContextType | null>(null);

export const RecordingControlsProvider = ({ children }: { children: ReactNode }) => {
  const dismissSilenceWarningRef = useRef<(() => void) | null>(null);
  const pauseRecordingRef = useRef<(() => void) | null>(null);
  const stopRecordingRef = useRef<(() => void) | null>(null);
  const continueRecordingRef = useRef<(() => void) | null>(null);

  return (
    <RecordingControlsContext.Provider value={{ dismissSilenceWarningRef, stopRecordingRef, continueRecordingRef, pauseRecordingRef }}>
      {children}
    </RecordingControlsContext.Provider>
  );
};

export const useRecordingControls = () => {
  const context = useContext(RecordingControlsContext);
  if (!context) {
    throw new Error("useRecordingControls must be used within RecordingControlsProvider");
  }
  return context;
};
